<template>
  <div class="deliverable-lists">
    <ul class="mb-0">
      <li
        v-if="deliverables.no_of_stories"
      >{{deliverables.no_of_stories}} x Story(ies)</li>
      <li
        v-if="deliverables.no_of_posts"
      >{{deliverables.no_of_posts}} x Post(s)</li>
      <li
        v-if="deliverables.no_of_tiktok_posts"
      >{{deliverables.no_of_tiktok_posts}} x TikTok Post(s)</li>
      <li
        v-if="deliverables.no_of_carousels"
      >{{deliverables.no_of_carousels}} x Carousel(s)</li>
      <li
        v-if="deliverables.no_of_video"
      >{{deliverables.no_of_video}} x Video(s)</li>
      <li
        v-if="deliverables.no_of_reels"
      >{{deliverables.no_of_reels}} x IG Reel(s)</li>
      <li
        v-if="deliverables.no_of_xhs_posts"
      >{{deliverables.no_of_xhs_posts}} x XHS Post(s)</li>
      <li
        v-if="deliverables.no_of_fb_posts"
      >{{deliverables.no_of_fb_posts}} x FB Post(s)</li>
      <li
        v-if="deliverables.no_of_li_posts"
      >{{deliverables.no_of_li_posts}} x LinkedIn Post(s)</li>
      <li
        v-if="deliverables.no_of_x_posts"
      >{{deliverables.no_of_x_posts}} x X (Twitter) Post(s)</li>
    </ul>
    <ul v-if='deliverables.custom && deliverables.custom.length > 0'>
      <li v-for="(custom, index) in deliverables.custom" :key="index">
        {{custom.value}} x {{custom.label}}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'PostDeliverables',
  props: ['deliverables']
}
</script>
<style scoped>
  .deliverable-lists {
    font-weight: 400;
  }
  .deliverable-lists ul{
    font-weight: 600;
  }
</style>




// WEBPACK FOOTER //
// Deliverables.vue?59d84565